import { HttpClient } from '@angular/common/http';

import { environment } from '../environments/environment';
import { ApplicationConfig, mergeConfigs } from './app-config.model';

export function initConfig(httpClient: HttpClient): () => Promise<any> {
  return () => {
    if (typeof appVolatile === 'undefined') {
      (window as any).appVolatile = {};
    }
    if (typeof appVersion === 'undefined') {
      (window as any).appVersion = environment.appVersion;
    }

    return new Promise((resolve) => {
      const conf = '/config.json';

      const setConfig = (config: ApplicationConfig) => {
        (window as any).appConfig = config;
        if (config.general.kitchenResources) {
          (window as any).env = { urls: { resources: config.general.kitchenResources } };
        }
      };

      httpClient.get(conf).subscribe(
        (response: object) => {
          setConfig(mergeConfigs(environment.defaultConfig, response));
          resolve(true);
        },
        () => {
          console.log(environment);
          setConfig(environment.appConfig);
          resolve(true);
        }
      );
    });
  };
}

export interface TelemetryConfig {
  enabled: boolean;
  endpoint?: string;
  url?: string;
}

let telemetryConfig: TelemetryConfig;

export function getTelemetryConfig(): TelemetryConfig {
  if (telemetryConfig) {
    return telemetryConfig;
  }
  const appConfig = (window as any).appConfig;
  if (!appConfig || !appConfig.blender || !appConfig.blender.telemetry) {
    return { enabled: false };
  }
  const config = appConfig.blender.telemetry as TelemetryConfig;
  config.url = appConfig.blender.url + config.endpoint;
  setTelemetryConfig(config);
  return config;
}

export function setTelemetryConfig(config: TelemetryConfig): void {
  telemetryConfig = config;
}
